import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-58" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-59" data-mp="1cf9nsi0k0hkr">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-ink md:text-4xl" data-id="element-60" data-mp="1ccdp2rgvtov9">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-61" data-mp="2546zu3e69i52">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-lg border border-line bg-cream" data-id="element-62" data-mp="1v580xcj7l0v9" data-mpi={index}>
                <h3 data-id="element-63" data-mp="opfbc1k5cv11">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-64" data-mp="opyutmpg3rh6">
                    <span data-id="element-65" data-mp="1aqc3flqs6zbp">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-earth transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-66" data-mp="1apat5jhlagv1" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-67" data-mp="16pieqq5ilghr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-68" data-mp="s0431begumz7">
                      <p className="border-t border-line px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-69" data-mp="myokpr3oauki">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}